import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {DqProductsDisplayView, HomeView} from '../../views';

const ProductsPage = () => {
    const history = useHistory();

    const data = {
    };

    // Actions handling business logic
    const actions = {
        navigateToProgramCreator: () => history.push('/program-creator'),
        navigateToProgramRating: () => history.push('/program-rating'),
        navigateToDQGuide: () => history.push('/dq-guide'),
    };

    // Configuration options for visual appearance
    const options = {
    };

    // Rendering the ProductDisplay view component
    return (
        <div>
            <HomeView
                data={data}
                actions={actions}
                options={options}
            />
        </div>
    );
};

export default ProductsPage;